import { createAsyncThunk } from "@reduxjs/toolkit"
import { AppId, AppThunkAPIType } from "../../../app/appTypes"
import { getWithAuth } from "../../../http"
import { ComputerizedSystem } from "../../computerizedSystems/computerizedSystemsApi"
import { GampCategory } from "../../computerizedSystems/gampDictionary"
import { Device } from "../../device/deviceSlice"
import { DeviceValidationStatus } from "../../supplierDeviceInstance/supplierDeviceInstanceApi"
import { ObjectValidationStatus } from "./validationProcessApi"

export type ValidatedObject 
    = { type: 'DEVICE', data: Device }
    | { type: 'ROOM', data: ValidatedRoom }
    | { type: 'COMPUTERIZED_SYSTEM', data: ComputerizedSystem }
    | { type: 'NONE', data: null }

export interface ValidatedDevice {
    id: number
    name: string
    description: string
    productionYear: number
    serialNo: string
    model: string
    structureId: number
    companyId: number | null
    warrantyStatus: string
    manufacturer: string
    validationStatus: DeviceValidationStatus
    guid: string
}

export interface ValidatedComputerizedSystem {
    id: number
    name: string
    description: string
    companyId: number
    structureId: number
    itOwnerId: string
    department: string
    status: string
    isGxpRelevant: boolean
    criticality: string
    validationStatus: ObjectValidationStatus
    validationDate: string | null
    nextReviewDate: string | null
    softwareVersion: string
    vendor: string
    backupDescription: string
    gampCategory: GampCategory
}

export interface ValidatedRoom {
}

export const loadProcessValidatedObject = createAsyncThunk<ValidatedObject, AppId, AppThunkAPIType>("process/load-validated-object", async (processId, { dispatch, rejectWithValue }) => {
    const result = await dispatch(getWithAuth({ url: `api/validated-object/for-process/${processId}`}))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as ValidatedObject
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})

export const loadDocumentValidatedObject = createAsyncThunk<ValidatedObject, AppId, AppThunkAPIType>("document/load-validated-object", async (docId, { dispatch, rejectWithValue }) => {
    const result = await dispatch(getWithAuth({ url: `api/validated-object/for-document/${docId}`}))
    const { payload } = result
    if (getWithAuth.fulfilled.match(result)) {
        return payload as ValidatedObject
    } else {
        return rejectWithValue(payload ?? { kind: 'unknown' })
    }
})
